<template>
    <div class="rrule-form">
        <div class="display-bar" @click="showForm=!showForm">
            <i class="fa fa-lg" :class="showForm ? 'fa-caret-up' : 'fa-caret-down'" />
            {{ showForm ? $t('hide') : $t('show') }}
            <i class="fa fa-lg" :class="showForm ? 'fa-caret-up' : 'fa-caret-down'" />
        </div>
        <div class="form-body" :class="{closed: !showForm}">
            <div class="flex parent">
                <div>
                    <label for="frecuency">{{$t('frecuency')}}</label>
                    <div class="custom-dropdown input">
                        <select name="frecuency" v-model="rrule.frecuency" @change="updateStr">
                            <option v-for="(value, frecuency) in frecuencies" :key="frecuency" :value="value">
                            {{$t(frecuency)}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="flex" v-if="rrule.frecuency==RRule.YEARLY">
                    <div class="custom-dropdown input">
                        <select name="anual-type" v-model="rrule.type" @change="updateStr">
                            <option v-for="(type) in anualType" :key="type" :value="type">
                            {{$t(type)}}
                            </option>
                        </select>
                    </div>
                    <div class="custom-dropdown input" v-if="rrule.type=='by_date_in_month'">
                        <select name="days" v-model="rrule.day" @change="updateStr">
                            <option v-for="(day) in monthDays[rrule.month-1]" :key="day" :value="day">
                            {{day}}
                            </option>
                        </select>
                    </div>
                    <div class="custom-dropdown input" v-if="rrule.type=='by_week_day_in_month'">
                        <select name="nth" v-model="rrule.nth" @change="updateStr">
                            <option v-for="(value, num) in nth" :key="num" :value="value">
                            {{$t(num)}}
                            </option>
                        </select>
                    </div>
                    <div class="custom-dropdown input" v-if="rrule.type=='by_week_day_in_month'">
                        <select name="weekDay" v-model="rrule.weekDay" @change="updateStr">
                            <option v-for="(value, weekDay) in weekDays" :key="weekDay" :value="value">
                            {{$t(weekDay)}}
                            </option>
                        </select>
                    </div>
                    <div class="input" v-if="rrule.type=='by_week_day_in_month'"> of </div>
                    <div class="custom-dropdown input">
                        <select name="month" v-model="rrule.month" @change="updateStr">
                            <option v-for="(month, index) in months" :key="month" :value="index+1">
                            {{$t(month)}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="flex" v-if="rrule.frecuency==RRule.MONTHLY">
                    <span>{{$t('every')}} <input type="number" v-model="rrule.interval" min="1" @blur="updateStr"/>{{$t('month_s')}}</span>
                    <div class="custom-dropdown input">
                        <select name="anual-type" v-model="rrule.type" @change="updateStr">
                            <option v-for="(type) in anualType" :key="type" :value="type">
                            {{$t(type)}}
                            </option>
                        </select>
                    </div>
                    <div class="custom-dropdown input" v-if="rrule.type=='by_date_in_month'">
                        <select name="days" v-model="rrule.day" @change="updateStr">
                            <option v-for="(day) in monthDays[0]" :key="day" :value="day">
                            {{day}}
                            </option>
                        </select>
                    </div>
                    <div class="custom-dropdown input" v-if="rrule.type=='by_week_day_in_month'">
                        <select name="nth" v-model="rrule.nth" @change="updateStr">
                            <option v-for="(value, num) in nth" :key="num" :value="value">
                            {{$t(num)}}
                            </option>
                        </select>
                    </div>
                    <div class="custom-dropdown input" v-if="rrule.type=='by_week_day_in_month'">
                        <select name="weekDay" v-model="rrule.weekDay" @change="updateStr">
                            <option v-for="(value, weekDay) in weekDays" :key="weekDay" :value="value">
                            {{$t(weekDay)}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="flex" v-if="rrule.frecuency==RRule.WEEKLY">
                    <span style="padding-right:.5em">{{$t('every')}} <input type="number" v-model="rrule.interval" min="1" @blur="updateStr"/> {{$t('week_s')}}</span>
                    <label class="checkBox" v-for="(value, weekDay) in weekDays" :key="weekDay" :for="weekDay" v-on:click.capture.stop>
                        <input type="checkbox" :id="weekDay" :value='value' v-model="rrule.weekDays" @change="updateStr">
                        <span class="checkmark"/>
                        {{$t(weekDay)}}
                    </label>
                </div>
                <div class="flex" v-if="rrule.frecuency==RRule.DAILY">
                    <span>{{$t('every')}} <input type="number" v-model="rrule.interval" min="1" @blur="updateStr"/> {{$t('day_s')}}</span>
                </div>
            </div>
            <div class="flex parent" id="rrules-end">
                <div class="custom-dropdown input">
                    <select name="ends" v-model="rrule.ends" @change="updateStr">
                        <option v-for="(end) in ends" :key="end" :value="end">
                        {{$t(end)}}
                        </option>
                    </select>
                </div>
                <span v-if="rrule.ends == 'ends_after'"><input type="number"  min="1" v-model="rrule.instances"  @blur="updateStr"/>{{$t('instance_s')}}</span>
            </div>
        </div>
        <div class="separator" />
    </div>
</template>
<script>
import moment from 'moment'
import { RRule } from 'rrule'
export default {
  name: 'rrule',
  data () {
    return {
      showForm: true,
      months: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
      weekDays: {monday: RRule.MO, tuesday: RRule.TU, wednesday: RRule.WE, thursday: RRule.TH, friday: RRule.FR, saturday: RRule.SA, sunday: RRule.SU},
      frecuencies: {yearly: RRule.YEARLY, monthly: RRule.MONTHLY, weekly: RRule.WEEKLY, daily: RRule.DAILY},
      anualType: ['by_date_in_month', 'by_week_day_in_month'],
      monthDays: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      nth: {'1st': 1, '2nd': 2, '3rd': 3, '4th': 4, 'last': -1},
      ends: ['ends_after'],
      RRule: RRule,
      rrule: {frecuency: RRule.YEARLY, type: 'by_date_in_month', day: moment().date(), month: moment().month() + 1, ends: 'ends_after'}
    }
  },
  computed: {
  },
  mounted () {
    this.updateStr()
  },
  methods: {
    updateStr () {
      var output = new RRule()
      output.options = {}
      if (this.rrule.type === 'by_date_in_month') {
        if (!this.rrule.day) this.rrule.day = moment().date()
        if (!this.rrule.month) this.rrule.month = moment().month()
      } else if (this.rrule.type === 'by_week_day_in_month') {
        if (!this.rrule.weekDay) this.rrule.weekDay = RRule.MO
        if (!this.rrule.nth) this.rrule.nth = '1st'
      }
      if (!this.rrule.weekDays) this.rrule.weekDays = []
      if (!this.rrule.interval) this.$set(this.rrule, 'interval', 1)
      if (!this.rrule.ends) this.rrule.ends = 'ends_after'
      if (!this.rrule.instances) this.rrule.instances = 1

      output.options.freq = this.rrule.frecuency
      if (this.rrule.frecuency === RRule.YEARLY || this.rrule.frecuency === RRule.MONTHLY) {
        if (this.rrule.type === 'by_date_in_month') {
          output.options.bymonthday = this.rrule.day
        } else {
          output.options.bynweekday = this.rrule.weekDay
          output.options.bysetpos = this.rrule.nth
        }
        if (this.rrule.frecuency === RRule.YEARLY) {
          output.options.bymonth = this.rrule.month
        }
      }
      if (this.rrule.frecuency !== RRule.YEARLY) {
        output.options.interval = this.rrule.interval
      }
      if (this.rrule.frecuency === RRule.WEEKLY) {
        output.options.byweekday = this.rrule.weekDays
      }
      if (this.rrule.ends === 'ends_after') output.options.count = this.rrule.instances

      this.$emit('generate', output)
    }
  }
}
</script>
<style lang="scss" scoped>
    .flex{
        align-items: flex-end;
        justify-content: center;
    }
    .parent{
        margin: .5em 0;
        box-sizing: border-box;
    }
    .input {
        margin: .1em 0em;
        box-sizing: border-box;
    }
    input[type="number"] {
        width:2em;
    }
    .checkBox{
        margin: 0 .3em;
        font-size: .8em;
        display: inline-flex;
        align-items: flex-end;
        .checkmark {
            position: relative;
            display: inline-block;
            margin-right: .1em;
        }
    }
    .display-bar {
        display: flex;
        justify-content: space-between;
        background: #009D97;
        border-radius: .3em;
        align-items: center;
        color: white;
        text-transform: uppercase;
        text-align: center;
        font-size: .9em;
        padding: .1em 1em;
        cursor: pointer;
        user-select: none;
    }
    .form-body {
        max-height: 400px;
        transition: max-height .3s ease-in;
        overflow: hidden;
    }
    .closed {
        max-height: 0;
        transition: max-height 1s ease-out;
        overflow: hidden;
    }
    .rrule-form {
        width:50em;
        margin: 0 auto;
    }
    .separator {
        background: #009D97;
        height: .05em;
        margin: .5em
    }
</style>



// WEBPACK FOOTER //
// src/components/RRuleForm.vue